import { VideoPlayer } from '@faithlife/video-player/dist/video-player.js';
import '@faithlife/video-player/dist/video-player.css';
import './video.scss';
export default VideoPlayer;
